import moment from 'moment';

import { createAction } from 'redux-actions';

import { AUTOSAVED_DRAFT_TYPES } from '../../util/autosaved-draft-types';

const saveSuccess = createAction('AUTOSAVE_DRAFT_SUCCESS');
export const autosaveDraft =
  (
    type: ValueOf<typeof AUTOSAVED_DRAFT_TYPES>,
    draftFields: {
      context: AutosaveContext;
      messageBody: string;
      messageType?: string;
      commentId?: number;
      subject?: string;
    },
  ) =>
  (dispatch: Function) => {
    dispatch(
      saveSuccess({
        type,
        draft: {
          savedAt: moment(),
          ...draftFields,
        },
      }),
    );
  };
